
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import tk.mallumo.compose.navigation.ArgumentsNavigation


fun one.devsbox.www.tools.ArgsId.fill(bundle: ArgumentsNavigation): one.devsbox.www.tools.ArgsId {
	id = bundle.long["id", id]
	return this
}
fun one.devsbox.www.tools.ArgsId.asBundle() = ArgumentsNavigation().apply{
	this.long["id"] = this@asBundle.id
}
fun one.devsbox.www.ui.resources.ArgsListingResource.fill(bundle: ArgumentsNavigation): one.devsbox.www.ui.resources.ArgsListingResource {
	pickerModeKey = bundle.string["pickerModeKey", pickerModeKey]
	return this
}
fun one.devsbox.www.ui.resources.ArgsListingResource.asBundle() = ArgumentsNavigation().apply{
	this.string["pickerModeKey"] = this@asBundle.pickerModeKey
}
